<!-- 
    FORM PARA INCLUSAO DE NOVOS USUARIOS/SEGUIDORES NO NEGOCIO

    FORM COMPLEMENTAR 
-->

<script>
import Vue from 'vue';
import { SysVars } from '../main';
import { apiORDSpost, apiORDS } from '../shared/api-functions'
import apiCrm from '../api/api-crm.js'

export default {
    props: {
        params: {},
    },
    
    components: {
        
    },

    data () {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,
            negociocrm: null,
            pessoa: null,
            organizacao: null,
            codseguidor: null,

            addingSeguidor: false,

            listSeguidores: [],
        }
    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    computed: {
        title: function () {
            return 'Vincular Usuários'
        },
    },

    methods: {
        handleDelete (index) {
            if (confirm("Confirma a exclusão?")) {
                let obj = { seguidor: this.listSeguidores[index] }
                obj.seguidor.excluido = true
                if (this.negociocrm) {
                    this.apiNegocio(obj, this.negociocrm.codnegocio).then(
                        this.listSeguidores.splice(index, 1)
                    )
                }
                if (this.pessoa) {
                    this.apiPessoa(obj, this.pessoa.codpessoa).then(
                        this.listSeguidores.splice(index, 1)
                    )
                }
                if (this.organizacao) {
                    this.apiOrg(obj, this.organizacao.codorg).then(
                        this.listSeguidores.splice(index, 1)
                    )
                }
            }
        },

        handleSalvar () {
            if (!this.codseguidor)
                return

            if (this.listSeguidores.filter(obj => { return obj.codusuario == this.codseguidor }).length > 0) {
              this.addingSeguidor = false
              return
            }
            
            let obj = { seguidor: { codusuario: this.codseguidor } }
            if (this.negociocrm) {
               obj.seguidor.codnegocio = this.negociocrm.codnegocio
               this.apiNegocio(obj, this.negociocrm.codnegocio, this.callBackSeguidor)
            }
            if (this.pessoa) {
               obj.seguidor.codpessoa = this.pessoa.codpessoa
               this.apiPessoa(obj, this.pessoa.codpessoa, this.callBackSeguidor)
            }
            if (this.organizacao) {
               obj.seguidor.codorg = this.organizacao.codorg
               this.apiOrg(obj, this.organizacao.codorg, this.callBackSeguidor)
            }
        },

        handleCancelSeguidor (index) {
                this.addingSeguidor = false
        },

        callBackSeguidor (data) {
            if (data) {
                if (this.addingSeguidor) {
                    this.listSeguidores = data.seguidores
                    if (this.negociocrm)
                      this.negociocrm.seguidores = data.seguidores
                    if (this.pessoa)
                      this.pessoa.seguidores = data.seguidores
                    if (this.organizacao)
                      this.organizacao.seguidores = data.seguidores
                }
                this.addingSeguidor = false
            }
        },

        handleIncluirSeguidor () {
            this.addingSeguidor = true
            this.codseguidor = null
            this.$nextTick(function () {
                if (this.$refs.seguidor) {
                    this.$refs.seguidor.focus()
                }
            })
        },

        closeForm () {
            this.$emit('closeform')
        },


    },

    watch: {

    },

    mounted () {
        if (this.negociocrm && this.negociocrm.seguidores) {
            this.listSeguidores = this.negociocrm.seguidores
        }
        if (this.organizacao && this.organizacao.seguidores) {
            this.listSeguidores = this.organizacao.seguidores
        }
        if (this.pessoa && this.pessoa.seguidores) {
            this.listSeguidores = this.pessoa.seguidores
        }
        if (this.listSeguidores.length == 0)
            this.handleIncluirSeguidor()
    },

    created () {
        if (this.params && this.params.negocio) {
           this.negociocrm = this.params.negocio
        } else
        if (this.params && this.params.pessoa) {
           this.pessoa = this.params.pessoa
        } else
        if (this.params && this.params.organizacao) {
           this.organizacao = this.params.organizacao
        }
    }

}

</script>

<template>
    <div class="nb-modal-scrollable">
        <div class="container nb-modal-scrollable-container" style="width: 600px; min-width: 500px; max-width: 100%">
            <div class="nb-modal-header" id="mymodal">
                <div class="row">
                    <div class="col-md-12 col-12">
                        <h4 class="def-title"> {{ title }} </h4>
                    </div>
                </div>
            </div>
            <div class="nb-modal-scrollable-body">
                <!-- LISTA DE USUARIOS -->
                <div class="mainbox mt-3" v-for="(item, index) in listSeguidores" :key="index">
                    <div class="row mb-2 align-items-center">
                        <div class="col-md-10">
                            <i class="fa fa-user-circle pr-2" aria-hidden="true" style="font-size: 18px"></i>
                            <span class="data-list">{{ item.usuario_nome }}</span>
                        </div>
                        <div class="col-md-2">
                            <v-button label="" icon="fa-trash" class="float-right" @click="handleDelete(index)"></v-button>
                        </div>
                    </div>
                </div>
                
                <div v-if="!addingSeguidor" class="row col mb-4">
                    <a style="cursor: pointer; color: #0091ea;" @click="handleIncluirSeguidor">Adicionar usuário</a>
                </div>

                <div v-if="addingSeguidor">
                    <div class="row">
                        <form-field v-model="codseguidor" type="select2" col="12" :metadata="metadata.seguidorcrm.codusuario" 
                            :select2="{entity: 'usuario', minlength: 0}"></form-field>
                        <div class="col-md-12 mb-3 text-right">
                            <v-button label="Cancelar" tabindex="1" @click="addingSeguidor = false"></v-button>
                            <v-button label="Salvar" icon="fa-download" :success="true" @click="handleSalvar"></v-button>
                        </div>
                    </div>
                </div>

            </div>
            <div class="modal-footer">
                <v-button label="Fechar" title="" @click="closeForm"></v-button>
            </div>
        </div>
    </div>

</template>

<style>

</style>


// WEBPACK FOOTER //
// src/forms-crm/crm-negocio-seguidores.vue